var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"projects"}},[_c('h1',[_vm._v("My Projects")]),_c('div',{attrs:{"id":"projects-container"}},_vm._l((_vm.projectList),function(project){return _c('ProjectItem',{key:project.id,attrs:{"project":project}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }